
export default [
    /* 非法路由重定向 */
    {
        path: '/',
        component: () => import('../views/portal/integrate/integratePortalFw.vue'),
        meta: { requireAuth: false, title: '顶部导航' },
        children:[
            {
                path: '/',
                component: () => import('../views/portal/cstIndex/cstIndex.vue'),
                meta: { requireAuth: false, title: '门户页' }
            },
            {
                path: '/cstIndex',
                component: () => import('../views/portal/cstIndex/cstIndex.vue'),
                meta: { requireAuth: false, title: '门户页' }
            },
            {
                path: '/appItemPortal/:id/:amId/:pageId/',
                component: () => import('../views/portal/integrate/integrateAppItemFw/integrateAppItemFw.vue'),
                meta: { requireAuth: false, title: '应用中心页' },
                children:[
                    {
                        path: 'list',
                        component: () => import('../views/worktbl/list/list.vue'),
                        meta: { requireAuth: false, title: '列表页' },
                    },
                    {
                        path: 'view',
                        component: () => import('../views/worktbl/list/list.vue'),
                        meta: { requireAuth: false, title: '列表页' },
                    },
                    {
                        path: 'bigScreen',
                        component: () => import('../views/bigscreen/bigScreenDtl/bigScreenDtl.vue'),
                        meta: { requireAuth: false, title: '大屏渲染页' },
                    },
                    {
                        path: 'page',
                        component: () => import('../views/page/pageDtl/pageDtl.vue'),
                        meta: { requireAuth: false, title: '自定义渲染页' },
                    },
                    {
                        path: 'report',
                        component: () => import('../views/report/reportView/reportDtl.vue'),
                        meta: { requireAuth: false, title: '报表页' },
                    },
                    {
                        path: 'portalDtl',
                        component: () => import('../views/itemPortal/portalDtl.vue'),
                        meta: { requireAuth: false, title: '门户页' },
                    },
                    {
                        path: '/blankAppIndex/:id/:amId',
                        component: () => import('../views/app/blankAppIndex.vue'),
                        meta: { requireAuth: false, title: '创建页面' },
                    },
                ]
            },
            {
                path: '/knowBase/kbNewFw',
                component: () => import('../views/knowBase/know/kbNewFw.vue'),
                meta: { requireAuth: false, title: '顶部导航',type:'KNOW' },
                children:[
                    {
                        path: '/knowBase/kbHome',
                        component: () => import('../views/knowBase/know/kbHome.vue'),
                        meta: { requireAuth: false, title: '知识库-首页',type:'KNOW' },
                    },
                    {
                        path: '/knowBase/kbList',
                        component: () => import('../views/knowBase/know/kbList.vue'),
                        meta: { requireAuth: false, title: '知识库-知识库列表',type:'KNOW' },
                    },
                    {
                        path: '/knowBase/mySelect',
                        component: () => import('../views/knowBase/know/kbMySelect.vue'),
                        meta: { requireAuth: false, title: '知识库-我收藏的',type:'KNOW' },
                    },
                    {
                        path: '/knowBase/myCrt',
                        component: () => import('../views/knowBase/know/myCrt.vue'),
                        meta: { requireAuth: false, title: '知识库-我创建的',type:'KNOW' },
                    },
                    {
                        path: '/knowBase/recycleBin',
                        component: () => import('../views/knowBase/know/recycleBin.vue'),
                        meta: { requireAuth: false, title: '知识库-知识库列表',type:'KNOW' },
                    },
                    {
                        path: '/knowBase/personSpace',
                        component: () => import('../views/knowBase/know/personSpace/mySpace.vue'),
                        meta: { requireAuth: false, title: '个人空间-我的空间',type:'KNOW' },
                        children:[
                            {
                                path: '/knowBase/personSpace',
                                component: () => import('../views/knowBase/kbDtl/kbDtlFw.vue'),
                                meta: { requireAuth: false, title: '知识库详情-左右框架',type:'KNOW' },
                                children: [
                                    {
                                        path: '/knowBase/personSpace/mySpace',
                                        component: () => import('../views/knowBase/kbDtl/kbPage.vue'),
                                        meta: { requireAuth: false, title: '知识库详情',type:'KNOW' },
                                    }
                                ]
                            },
                        ]
                    },
                    {
                        path: '/knowBase/personSpace',
                        component: () => import('../views/knowBase/know/personSpace/myShare.vue'),
                        meta: { requireAuth: false, title: '个人空间-我的分享',type:'KNOW' },
                        children:[
                            {
                                path: '/knowBase/personSpace',
                                component: () => import('../views/knowBase/kbDtl/kbDtlFw.vue'),
                                meta: { requireAuth: false, title: '知识库详情-左右框架',type:'KNOW' },
                                children: [
                                    {
                                        path: '/knowBase/personSpace/shareSpace',
                                        component: () => import('../views/knowBase/kbDtl/kbPage.vue'),
                                        meta: { requireAuth: false, title: '知识库详情',type:'KNOW' },
                                    }

                                ]
                            },
                        ]
                    },
                    {
                        path: '/knowBase/kbDtl/kbDtlFw',
                        component: () => import('../views/knowBase/kbDtl/kbDtlFw.vue'),
                        meta: { requireAuth: false, title: '知识库详情-左右框架',type:'KNOW' },
                        children: [
                            {
                                path: '/knowBase/kbDtl/kbPage',
                                component: () => import('../views/knowBase/kbDtl/kbPage.vue'),
                                meta: { requireAuth: false, title: '知识库详情',type:'KNOW' },
                            }
                        ]
                    },
                ]
            },
            {
                path: '/bizFlow',
                component: () => import('../views/bizFlow/bizFlowPortal.vue'),
                meta: { requireAuth: false, title: '流程通框架页',type:'BPA' },
                children:[
                    {
                        path: 'myWorks/myPostJob',
                        component: () => import('../views/bizFlow/myWorks/myPostJob.vue'),
                        meta: { requireAuth: false, title: '岗位职责',type:'BPA' },
                    },
                    {
                        path: 'myWorks/myAuthorize',
                        component: () => import('../views/bizFlow/myWorks/myAuthorize.vue'),
                        meta: { requireAuth: false, title: '授权',type:'BPA' },
                    },
                    {
                        path: 'myWorks/myCapability',
                        component: () => import('../views/bizFlow/myWorks/myCapability.vue'),
                        meta: { requireAuth: false, title: '能力体系',type:'BPA' },
                    },
                    {
                        path: 'myWorks/myFile',
                        component: () => import('../views/bizFlow/myWorks/myFile.vue'),
                        meta: { requireAuth: false, title: '相关文档',type:'BPA' },
                    },
                    {
                        path: 'myWorks/myFlowList',
                        component: () => import('../views/bizFlow/myWorks/myFlowList.vue'),
                        meta: { requireAuth: false, title: '相关流程',type:'BPA' },
                    },
                    {
                        path: 'myWorks/myIndex',
                        component: () => import('../views/bizFlow/myWorks/myIndex.vue'),
                        meta: { requireAuth: false, title: '绩效指标',type:'BPA' },
                    },
                    {
                        path: 'myWorks/myItSys',
                        component: () => import('../views/bizFlow/myWorks/myItSys.vue'),
                        meta: { requireAuth: false, title: 'it系统',type:'BPA' },
                    },
                    {
                        path: 'myWorks/myRisk',
                        component: () => import('../views/bizFlow/myWorks/myRisk.vue'),
                        meta: { requireAuth: false, title: '风险',type:'BPA' },
                    },
                    {
                        path: 'myWorks/mySystem',
                        component: () => import('../views/bizFlow/myWorks/mySystem.vue'),
                        meta: { requireAuth: false, title: '制度',type:'BPA' },
                    },
                    {
                        path: 'myWorks/myTerminology',
                        component: () => import('../views/bizFlow/myWorks/myTerminology.vue'),
                        meta: { requireAuth: false, title: '专业名词',type:'BPA' },
                    },
                    {
                        path: 'flowMgt/myFlowGroup',
                        component: () => import('../views/bizFlow/flowMgt/myFlowGroup.vue'),
                        meta: { requireAuth: false, title: '流程小组',type:'BPA' },
                    },
                    {
                        path: 'flowMgt/myMgtFlow',
                        component: () => import('../views/bizFlow/flowMgt/myMgtFlow.vue'),
                        meta: { requireAuth: false, title: '管理流程',type:'BPA' },
                    },
                    {
                        path: 'flowMgt/myPubFlow',
                        component: () => import('../views/bizFlow/flowMgt/myPubFlow.vue'),
                        meta: { requireAuth: false, title: '流程发布',type:'BPA' },
                    },
                    {
                        path: 'flowMgt/myFeedBack',
                        component: () => import('../views/bizFlow/flowMgt/myFeedBack.vue'),
                        meta: { requireAuth: false, title: '流程反馈',type:'BPA' },
                    },
                ]
            },
            {
                path: '/examStu',
                component: () => import('../views/examStu/portal/portalFw.vue'),
                meta: { requireAuth: false, title: '学员培训框架',type:'examStu' },
                redirect: '/examStu/myTrain',
                children:[
                    {
                        path: '/examStu/myTrain',
                        component: () => import('../views/examStu/train/myTrain.vue'),
                        meta: { requireAuth: false, title: '培训列表页',type:'examStu' },
                    },
                    {
                        path: '/examStu/myTrain/detail',
                        component: () => import('../views/examStu/train/myTrainDetail.vue'),
                        meta: { requireAuth: false, title: '培训详情页',type:'examStu' },
                    },
                    {
                        path: '/examStu/myJobCourse',
                        component: () => import('../views/examStu/course/myJobCourse.vue'),
                        meta: { requireAuth: false, title: '岗位课程页',type:'examStu' },
                    },
                    {
                        path: '/examStu/myJobCourse/detail',
                        component: () => import('../views/examStu/course/courseDetail.vue'),
                        meta: { requireAuth: false, title: '岗位课程详情页',type:'examStu' },
                    },
                    {
                        path: '/examStu/myExam',
                        component: () => import('../views/examStu/exam/myExam.vue'),
                        meta: { requireAuth: false, title: '考试列表页',type:'examStu' },
                    },
                    {
                        path: '/examStu/mySignIn',
                        component: () => import('../views/examStu/course/mySignIn.vue'),
                        meta: { requireAuth: false, title: '签到列表页',type:'examStu' },
                    },
                    {
                        path: '/examStu/myCertificate',
                        component: () => import('../views/examStu/certificate/myCertificate.vue'),
                        meta: { requireAuth: false, title: '证书列表页',type:'examStu' },
                    },
                    {
                        path: '/examStu/myFeedback',
                        component: () => import('../views/examStu/feedback/myFeedback.vue'),
                        meta: { requireAuth: false, title: '我的反馈',type:'examStu' },
                    },
                    {
                        path: '/examStu/examResult',
                        component: () => import('../views/examStu/exam/examResult.vue'),
                        meta: { requireAuth: false, title: '考试分析页',type:'examStu' },
                    },
                    {
                        path: '/examStu/courseCenter',
                        component: () => import('../views/examStu/courseCenter/courseCenter.vue'),
                        meta: { requireAuth: false, title: '课程中心',type:'examStu' },
                    },
                ]
            },
            {
                path: '/AIPartner/AIPartnerFw',
                component: () => import('../views/AIPartner/AIPartnerFw.vue'),
                meta: { requireAuth: false, title: 'AI伙伴',type:'AI' },
                children:[]
            },
            {
                path: '/emailPortal/emailPortalFw',
                component: () => import('../views/email/emailPortalFw.vue'),
                meta: { requireAuth: false, title: '邮件',type:'EMAIL' },
                children:[
                    {
                        path: '/emailPortal/emailDel',
                        component: () => import('../views/email/emailPage/emailDel.vue'),
                        meta: { requireAuth: false, title: '邮件',type:'EMAIL' },
                        children:[]
                    },
                    {
                        path: '/emailPortal/emailDraft',
                        component: () => import('../views/email/emailPage/emailDraft.vue'),
                        meta: { requireAuth: false, title: '邮件',type:'EMAIL' },
                        children:[]
                    },
                    {
                        path: '/emailPortal/emailFinish',
                        component: () => import('../views/email/emailPage/emailFinish.vue'),
                        meta: { requireAuth: false, title: '邮件',type:'EMAIL' },
                        children:[]
                    },
                    {
                        path: '/emailPortal/emailSend',
                        component: () => import('../views/email/emailPage/emailSend.vue'),
                        meta: { requireAuth: false, title: '邮件',type:'EMAIL' },
                        children:[]
                    },
                    {
                        path: '/emailPortal/emailReceive',
                        component: () => import('../views/email/emailPage/emailReceive.vue'),
                        meta: { requireAuth: false, title: '邮件',type:'EMAIL' },
                        children:[]
                    },
                    {
                        path: '/emailPortal/emailSpan',
                        component: () => import('../views/email/emailPage/emailSpan.vue'),
                        meta: { requireAuth: false, title: '邮件',type:'EMAIL' },
                        children:[]
                    },
                    {
                        path: '/emailPortal/emailStar',
                        component: () => import('../views/email/emailPage/emailStar.vue'),
                        meta: { requireAuth: false, title: '邮件',type:'EMAIL' },
                        children:[]
                    },
                ]
            },
            {
                path: '/selfBuildApp/selfBuildAppMgt',
                component: () => import('../views/selfBuildApp/selfBuildAppMgt.vue'),
                meta: {requireAuth: false,title: '自建应用',type:'zjyy'}
            },
            {
                path: '/selfBuildApp/selfBuildLogin',
                component: () => import('../views/selfBuildApp/selfBuildLogin.vue'),
                meta: {requireAuth: false,title: '自建应用授权',type:'zjyy'}
            },
            {
                path: '/communityPortal',
                component: () => import('../views/communityPortal/communityPortalFw.vue'),
                meta: {requireAuth: false,title: '社区门户',type:'communityPortal'},
                children:[
                    // {
                    //     path: '',
                    //     component: () => import('../views/communityPortal/communityPage/allPosts.vue'),
                    //     meta: { requireAuth: false, title: '社区帖子' },
                    // },
                    // {
                    //     path: '',
                    //     component: () => import('../views/communityPortal/communityPage/modulePosts.vue'),
                    //     meta: { requireAuth: false, title: '板块帖子' },
                    // },
                    {
                        path: 'modulePosts/:id',
                        component: () => import('../views/communityPortal/communityPage/modulePosts.vue'),
                        meta: { requireAuth: false, title: '板块帖子' },
                    },
                    // {
                    //     path: 'personalPosts/:id',
                    //     component: () => import('../views/communityPortal/communityPage/personalPosts.vue'),
                    //     meta: { requireAuth: false, title: '个人帖子' },
                    // },
                    // {
                    //     path: 'postShow/:id',
                    //     component: () => import('../views/communityPortal/communityPage/postShow.vue'),
                    //     meta: { requireAuth: false, title: '帖子详细' },
                    // },
                ]
            },
            {
                path: '/communityPortal/addPost',
                component: () => import('../views/communityPortal/communityPage/addPost.vue'),
                meta: { requireAuth: false, title: '添加帖子' },
            },
            {
                path: '/communityPortal/postShow/:id',
                component: () => import('../views/communityPortal/communityPage/postShow.vue'),
                meta: { requireAuth: false, title: '帖子详细' },
            },
            {
                path: '/communityPortal/personalPosts/:id',
                component: () => import('../views/communityPortal/communityPage/personalPosts.vue'),
                meta: { requireAuth: false, title: '个人帖子' },
            },
            {
                path: '/communityPortal/searchPost',
                component: () => import('../views/communityPortal/communityPage/searchPost.vue'),
                meta: { requireAuth: false, title: '社区帖子' },
            }
        ]
    },
    {
        path: '/selfBuildApp/outSelfBuildLogin',
        component: () => import('../views/selfBuildApp/selfBuildLogin.vue'),
        meta: {requireAuth: false,title: '自建应用授权',type:'selfBuildApp'}
    },
    {
        path: '/examStu/examination',
        component: () => import('../views/examStu/exam/examination.vue'),
        meta: { requireAuth: false, title: '考试中页' ,type:'examStu'},
        children:[]
    },
    {
        path:'/examStu/courseSignIn',
        component: ()=>import('../views/examStu/course/courseSignIn.vue'),
        meta: { requireAuth: false, title: '课程签到' },
        children:[]
    },
    {
        path: '/bizFlow/flowSet',
        component: () => import('../views/bizFlow/flowSetConfig/flowSetPortal.vue'),
        meta: { requireAuth: false, title: '流程通-流程配置',type:'BPA' },
        children:[
            {
                path: 'fsDesigner',
                component: () => import('../views/bizFlow/flowStructGraph/fsDesigner.vue'),
                meta: { requireAuth: false, title: '桌面端流程配置',type:'BPA' },
            },
            {
                path: 'fwDesigner',
                component: () => import('../views/bizFlow/flowSwimGraph/fwDesigner.vue'),
                meta: { requireAuth: false, title: '桌面端流程配置',type:'BPA' },
            },
            {
                path: 'flowInfo',
                component: () => import('../views/bizFlow/flowSetConfig/flowInfo/flowInfo.vue'),
                meta: { requireAuth: false, title: '关键节点',type:'BPA' },
            },
        ],
    },
    {
        path: '/bizFlow/flowAuth',
        component: () => import('../views/bizFlow/flowAuth/flowAuthPortal.vue'),
        meta: { requireAuth: false, title: '流程通-流程权限配置',type:'BPA' },
        children:[
            {
                path: '/bizFlow/flowAuthSet',
                component: () => import('../views/bizFlow/flowAuth/flowAuthSet.vue'),
                meta: { requireAuth: false, title: '桌面端流程配置',type:'BPA' },
            },
        ],
    },
    {
        path: '/bizFlow/flowBoardPortal',
        component: () => import('../views/bizFlow/flowBoard/flowBoardPortal.vue'),
        meta: { requireAuth: false, title: '流程通-流程权限配置',type:'BPA' },
        children:[
            {
                path: '/bizFlow/flowBoard',
                component: () => import('../views/bizFlow/flowBoard/flowBoard.vue'),
                meta: { requireAuth: false, title: '桌面端流程配置',type:'BPA' },
            },
        ],
    },
    {
        path: '/bizFlow/flowAssets',
        component: () => import('../views/bizFlow/flowAssets/flowAssetsPortal.vue'),
        meta: { requireAuth: false, title: '流程通-流程资产库',type:'BPA' },
        children:[
            {
                path: 'flowAssets',
                component: () => import('../views/bizFlow/flowAssets/assets/flowAssets.vue'),
                meta: { requireAuth: false, title: '流程资产',type:'BPA' },
            },
            {
                path: 'flowFile',
                component: () => import('../views/bizFlow/flowAssets/assets/flowFile.vue'),
                meta: { requireAuth: false, title: '流程文件',type:'BPA' },
            },
            {
                path: 'postJob',
                component: () => import('../views/bizFlow/flowAssets/org/postJob.vue'),
                meta: { requireAuth: false, title: '岗位职责',type:'BPA' },
            },
            {
                path: 'valueChain',
                component: () => import('../views/bizFlow/flowAssets/businessModel/valueChain.vue'),
                meta: { requireAuth: false, title: '价值链',type:'BPA' },
            },
            {
                path: 'prdtAndService',
                component: () => import('../views/bizFlow/flowAssets/businessModel/prdtAndService.vue'),
                meta: { requireAuth: false, title: '产品与服务',type:'BPA' },
            },
            {
                path: 'busMode',
                component: () => import('../views/bizFlow/flowAssets/businessModel/busMode.vue'),
                meta: { requireAuth: false, title: '商业模式',type:'BPA' },
            },
            {
                path: 'system',
                component: () => import('../views/bizFlow/flowAssets/mgtFactor/system.vue'),
                meta: { requireAuth: false, title: '制度',type:'BPA' },
            },
            {
                path: 'risk',
                component: () => import('../views/bizFlow/flowAssets/mgtFactor/risk.vue'),
                meta: { requireAuth: false, title: '风险',type:'BPA' },
            },
            {
                path: 'index',
                component: () => import('../views/bizFlow/flowAssets/mgtFactor/index.vue'),
                meta: { requireAuth: false, title: '绩效',type:'BPA' },
            },
            {
                path: 'authorize',
                component: () => import('../views/bizFlow/flowAssets/mgtFactor/authorize.vue'),
                meta: { requireAuth: false, title: '授权',type:'BPA' },
            },
            {
                path: 'capability',
                component: () => import('../views/bizFlow/flowAssets/mgtFactor/capability.vue'),
                meta: { requireAuth: false, title: '能力体系',type:'BPA' },
            },
            {
                path: 'terminology',
                component: () => import('../views/bizFlow/flowAssets/mgtFactor/terminology.vue'),
                meta: { requireAuth: false, title: '名词术语',type:'BPA' },
            },
            {
                path: 'itSys',
                component: () => import('../views/bizFlow/flowAssets/mgtFactor/itSys.vue'),
                meta: { requireAuth: false, title: 'IT',type:'BPA' },
            },
            {
                path: 'recycleBin',
                component: () => import('../views/bizFlow/flowAssets/recycle/recycleBin.vue'),
                meta: { requireAuth: false, title: '回收站',type:'BPA' },
            },
        ],
    },
    {
        path: '/testPage/:id/:amId/:pageId/',
        component: () => import('../views/worktbl/list/containList.vue'),
        meta: { requireAuth: false, title: '应用中心页' },
        children:[
            {
                path: 'list',
                component: () => import('../views/worktbl/list/list.vue'),
                meta: { requireAuth: false, title: '列表页' },
            },
            {
                path: 'view',
                component: () => import('../views/worktbl/list/list.vue'),
                meta: { requireAuth: false, title: '列表页' },
            },
            {
                path: 'bigScreen',
                component: () => import('../views/bigscreen/bigScreenDtl/bigScreenDtl.vue'),
                meta: { requireAuth: false, title: '大屏渲染页' },
            },
            {
                path: 'page',
                component: () => import('../views/page/pageDtl/pageDtl.vue'),
                meta: { requireAuth: false, title: '自定义渲染页' },
            },
            {
                path: 'report',
                component: () => import('../views/report/reportView/reportDtl.vue'),
                meta: { requireAuth: false, title: '报表页' },
            },
            {
                path: 'portalDtl',
                component: () => import('../views/itemPortal/portalDtl.vue'),
                meta: { requireAuth: false, title: '门户页' },
            },
            {
                path: '/blankAppIndex/:id/:amId',
                component: () => import('../views/app/blankAppIndex.vue'),
                meta: { requireAuth: false, title: '创建页面' },
            },
        ]
    },
    {
        path: '/fullScreenCstDtl',
        component: () => import('../views/worktbl/fullScreenCstDtl.vue'),
        meta: { requireAuth: false, title: '表单全屏' },
        children:[]
    },
    {
        path: '/pub/',
        component: ()  => import('../views/pub/portal/pubPortal.vue'),
        meta: { requireAuth: false, title: '登录注册头部导航' },
        children: [
            {
                path: 'pswdLogin',
                component: () =>  import('../views/pub/pswdLogin.vue'),
                meta: { requireAuth: false, title: '登录密码页' }
            },

            {
                path: 'overDate',
                component: () =>  import('../views/pub/overDate.vue'),
                meta: { requireAuth: false, title: '版本到期提示' }
            },
            {
                path: 'joinOrgByCode',
                component: ()  =>  import('../views/pub/joinOrgByCode.vue'),
                meta: { requireAuth: false, title: '组织码加入组织' }
            },
            {
                path: '/joinOrg',
                component: ()  =>  import('../views/pub/joinOrg.vue'),
                meta: { requireAuth: false, title: '组织码加入组织' }
            },
            {
                path: 'forgetPswd',
                component: ()  =>import('../views/pub/forgetPswd.vue'),
                meta: { requireAuth: false, title: '重置密码页' }
            },
            {
                path: 'regOrg',
                component: ()  => import('../views/pub/regOrg.vue'),
                meta: { requireAuth: false, title: '注册组织页' }
            },
            {
                path: 'regOrgResult',
                component: ()  =>import('../views/pub/regOrgResult.vue'),
                meta: { requireAuth: false, title: '注册结果页' }
            },
            {
                path: 'forgetPswd',
                component: ()  =>import('../views/pub/forgetPswd.vue'),
                meta: { requireAuth: false, title: '忘记密码' }
            },
            {
                path: 'term',
                component: ()  =>import('../views/pub/term.vue'),
                meta: { requireAuth: false, title: '服务条款' }
            },
            {
                path: 'externalEmpLogin',
                component: ()  =>import('../views/pub/externalEmpLogin.vue'),
                meta: { requireAuth: false, title: '外部用户登录' }
            },
            {
                path: 'externalEmpApply',
                component: ()  =>import('../views/pub/externalEmpApply.vue'),
                meta: { requireAuth: false, title: '外部用户注册' }
            },
            {
                path: 'publicExamRegist',
                component: ()  =>import('../views/examStu/exam/publicExamRegist.vue'),
                meta: { requireAuth: false, title: '公开考试报名' }
            },
        ]
    },
    {
        path: '/pub/examStu/publicExam',
        component: () => import('../views/examStu/exam/publicExam.vue'),
        meta: { requireAuth: false, title: '公开考试试卷',type:'examStu' },
    },
    {
        path: '/pub/examStu/examination',
        component: () => import('../views/examStu/exam/examination.vue'),
        meta: { requireAuth: false, title: '考试中页',type:'examStu' },
        children:[]
    },
    {
        path: '/pub/qywxInstallLogin',
        component: () =>  import('../views/pub/qywx/qywxInstallLogin.vue'),
        meta: { requireAuth: false, title: '企业微信下载登录' }
    },
    {
        path: '/pub/qywxSkip',
        component: () =>  import('../views/pub/qywx/qywxSkip.vue'),
        meta: { requireAuth: false, title: '企业微信跳转' }
    },
    {
        path: '/pub/qywxInstallLoginH5',
        component: () =>  import('../views/pub/qywx/qywxInstallLoginH5.vue'),
        meta: { requireAuth: false, title: '企业微信下载登录H5' }
    },
    {
        path: '/pub/dingdingLogin',
        component: () =>  import('../views/pub/dingdingLogin/dingdingLogin.vue'),
        meta: { requireAuth: false, title: '钉钉登录' }
    },
    {
        path: '/pub/dingdingLoginH5',
        component: () =>  import('../views/pub/dingdingLogin/dingdingLoginH5.vue'),
        meta: { requireAuth: false, title: '钉钉登录H5' }
    },
    {
        path: '/pub/qywxLogin',
        component: () =>  import('../views/pub/qywx/qywxLogin.vue'),
        meta: { requireAuth: false, title: '企业微信登录' }
    },
    {
        path: '/bigscreen/',
        component: () => import('../views/bigscreen/bigScreenConfig/bigScreenConfigFw.vue'),
        meta: { requireAuth: false, title: '大屏配置' },
        children:[
            {
                path: 'designer/:id',
                component: () => import('../views/bigscreen/bigScreenConfig/bigScreenDesigner.vue'),
                meta: { requireAuth: false, title: '大屏设计' },
            },
        ]
    },
    { 
        path: '/page/',
        component: () => import('../views/page/pageConfig/pageConfigFw.vue'),
        meta: { requireAuth: false, title: '页面配置' },
        children:[
            {
                path: 'pageDesigner/:id',
                component: () => import('../views/page/pageConfig/pageDesigner.vue'),
                meta: { requireAuth: false, title: '桌面端配置' },
            },
            {
                path: 'pageMobileDesigner/:id',
                component: () => import('../views/page/pageConfig/pageMobileDesigner.vue'),
                meta: { requireAuth: false, title: '移动端配置' },
            }
        ]
    },
    { 
        path: '/tplInstall',
        component: () => import('../views/appTpl/tplInstall.vue'),
        meta: { requireAuth: false, title: '模板安装跳转页' },
    },
    {
        path: '/worktbl/workTblConfig',
        component: () => import('../views/worktbl/workTblConfig/workTblConfigFw.vue'),
        meta: { requireAuth: false, title: '工作表配置' },
        children: [
            {
                path: '/worktbl/workTblConfig/formDesigner/:id/:amId/:wtId',
                component: () => import('../views/worktbl/workTblConfig/formDesigner.vue'),
                meta: { requireAuth: false, title: '表单设计' },
            },
            {
                path: '/worktbl/workTblConfig/workTblSetting/:id/:amId/:wtId',
                component: () => import('../views/worktbl/workTblConfig/workTblSetting.vue'),
                meta: { requireAuth: false, title: '表单设置' },
            },
            {
                path: '/worktbl/workTblConfig/publicIssue/:id/:amId/:wtId',
                component: () => import('../views/worktbl/workTblConfig/publicIssue/pubSwitch.vue'),
                meta: { requireAuth: false, title: '表单公开' },
            },
            {
                path: '/worktbl/workTblConfig/cstDtl/:id/:amId/:wtId',
                component: () => import('../views/worktbl/workTblConfig/cstDtl/cstDtl.vue'),
                meta: { requireAuth: false, title: '自定义详情页' },
            },
        ]
    },
    {
        path: '/viewCollect/viewConfig',
        component: () => import('../views/viewCollect/viewConfigFw.vue'),
        meta: { requireAuth: false, title: '视图表单配置' },
        children: [
            {
                path: '/viewCollect/viewConfig/formDesigner/:id/:amId/:wtId',
                component: () => import('../views/worktbl/workTblConfig/formDesigner.vue'),
                meta: { requireAuth: false, title: '表单设计' },
            },
        ]
    },
    {
        path: '/workTblLayout/viewConfig',
        component: () => import('../views/worktbl/workTblConfig/workLayoutSetting/viewConfigFw.vue'),
        meta: { requireAuth: false, title: '视图表单配置' },
        children: [
            {
                path: '/workTblLayout/viewConfig/formDesigner/:id/:amId/:wtId',
                component: () => import('../views/worktbl/workTblConfig/formDesigner.vue'),
                meta: { requireAuth: false, title: '表单设计' },
            },
        ]
    },
    { 
        path: '/appTpl/',
        component: () => import('../views/appTpl/appTplFw.vue'),
        meta: { requireAuth: false, title: '模板中心框架页' },
        children:[
            {
                path: 'tplIndex',
                component: () => import('../views/appTpl/tplIndex.vue'),
                meta: { requireAuth: false, title: '模板中心入口' },
            },
            {
                path: 'tplSearch',
                component: () => import('../views/appTpl/tplSearchList.vue'),
                meta: { requireAuth: false, title: '模板中心搜索页' },
            },
            {
                path: 'tplDtl/:tplId',
                component: () => import('../views/appTpl/tplDtl.vue'),
                meta: { requireAuth: false, title: '模板中心详情' },
            },
        ]
    },
    {
        path: '/user/',
        component: () => import('../views/user/userFw.vue'),
        meta: { requireAuth: false, title: '个人中心',type:'grzx' },
        children:[
            {
                path: 'userInfo',
                component: () => import('../views/user/userInfo.vue'),
                meta: { requireAuth: false, title: '个人信息',type:'grzx' },
            },
            {
                path: 'userOrg',
                component: () => import('../views/user/userOrg.vue'),
                meta: { requireAuth: false, title: '我的组织',type:'grzx' },
            },
            {
                path: 'userSecure',
                component: () => import('../views/user/userSecure.vue'),
                meta: { requireAuth: false, title: '安全设置',type:'grzx' },
            },
            {
                path: 'userInvite',
                component: () => import('../views/user/userInvite.vue'),
                meta: { requireAuth: false, title: '邀请加入',type:'grzx' },
            },
            {
                path: 'prefer',
                component: () => import('../views/user/prefer.vue'),
                meta: { requireAuth: false, title: '偏好设置',type:'grzx' },
            },
        ]
    },
    {
        path: '/flow/flowList/flowListFw/:id',
        component: () => import('../views/flow/flowList/flowListFw.vue'),
        meta: { requireAuth: false, title: '流程列表框架页' },
        children: [
            {
                path: '/flow/flowList/tblTriggerList/:id',
                component: () => import('../views/flow/flowList/tblTriggerList.vue'),
                meta: { requireAuth: false, title: '表相关触发流程列表' },
            }
        ]
    },
    {
        path: '/appAuth/:id',
        component: () => import('../views/appauth/appauthconfig/roleList.vue'),
        meta: { requireAuth: false, title: '角色权限' },
    },
    {
        path: '/flow/flowConfig',
        component: () => import('../views/flow/flowConfig/flowConfigFw.vue'),
        meta: { requireAuth: false, title: '流程配置' },
        children: [
            {
                path: '/flow/flowConfig/flowDesigner',
                component: () => import('../views/flow/flowConfig/flowDesign/flowDesigner.vue'),
                meta: { requireAuth: false, title: '流程设计' },
            },
            {
                path: '/flow/flowConfig/flowSetFw',
                component: () => import('../views/flow/flowConfig/flowSet/flowSetFw.vue'),
                meta: { requireAuth: false, title: '流程设置-框架页' },
                children: [
                    {
                        path: '/flow/flowConfig/baseSet',
                        component: () => import('../views/flow/flowConfig/flowSet/baseSet.vue'),
                        meta: { requireAuth: false, title: '流程设置-基础设置' },
                    },
                    {
                        path: '/flow/flowConfig/manualSet',
                        component: () => import('../views/flow/flowConfig/flowSet/manualSet.vue'),
                        meta: { requireAuth: false, title: '流程设置-人工节点设置' },
                    },
                    {
                        path: '/flow/flowConfig/notifySet',
                        component: () => import('../views/flow/flowConfig/flowSet/notifySet.vue'),
                        meta: { requireAuth: false, title: '流程设置-通知设置' },
                    },
                ]
            },
        ]
    },
    {
        path: '/flow/workbentch/pExam',
        component: () => import('../views/flow/workbentch/wbFw.vue'),
        meta: { requireAuth: false, title: '流程中心',type:'FLOW' },
        children: [
            {
                path: '/flow/workbentch/pExam',
                component: () => import('../views/flow/workbentch/mywork/pendding/pExam.vue'),
                meta: { requireAuth: false, title: '待办-待我审批',type:'FLOW' },
            },
            {
                path: '/flow/workbentch/pDeal',
                component: () => import('../views/flow/workbentch/mywork/pendding/pDeal.vue'),
                meta: { requireAuth: false, title: '待办-待我处理',type:'FLOW' },
            },
            {
                path: '/flow/workbentch/pCc',
                component: () => import('../views/flow/workbentch/mywork/pendding/pCc.vue'),
                meta: { requireAuth: false, title: '待办-待我查阅',type:'FLOW' },
            },
            {
                path: '/flow/workbentch/pFinish',
                component: () => import('../views/flow/workbentch/mywork/pendding/pFinish.vue'),
                meta: { requireAuth: false, title: '待办-待我完成',type:'FLOW' },
            },
            {
                path: '/flow/workbentch/pCreate',
                component: () => import('../views/flow/workbentch/mywork/pendding/pCreate.vue'),
                meta: { requireAuth: false, title: '待办-我发起的',type:'FLOW' },
            },
            {
                path: '/flow/workbentch/fExam',
                component: () => import('../views/flow/workbentch/mywork/finish/fExam.vue'),
                meta: { requireAuth: false, title: '已完成-我已审批',type:'FLOW' },
            },
            {
                path: '/flow/workbentch/fDeal',
                component: () => import('../views/flow/workbentch/mywork/finish/fDeal.vue'),
                meta: { requireAuth: false, title: '已完成-我已处理',type:'FLOW' },
            },
            {
                path: '/flow/workbentch/fCc',
                component: () => import('../views/flow/workbentch/mywork/finish/fCc.vue'),
                meta: { requireAuth: false, title: '已完成-我已查阅',type:'FLOW' },
            },
            {
                path: '/flow/workbentch/fCreate',
                component: () => import('../views/flow/workbentch/mywork/finish/fCreate.vue'),
                meta: { requireAuth: false, title: '已完成-我发起的',type:'FLOW' },
            },
            {
                path: '/flow/workbentch/fFinish',
                component: () => import('../views/flow/workbentch/mywork/finish/fFinish.vue'),
                meta: { requireAuth: false, title: '已完成-待我完成',type:'FLOW' },
            },
            {
                path: '/flow/workbentch/flowAgency',
                component: () => import('../views/flow/workbentch/mywork/personSet/agency/flowAgency.vue'),
                meta: { requireAuth: false, title: '个人设置-流程委托',type:'FLOW' },
            },
            {
                path: '/flow/workbentch/offensuggest',
                component: () => import('../views/flow/workbentch/mywork/personSet/offensuggest.vue'),
                meta: { requireAuth: false, title: '个人设置-常见意见',type:'FLOW' },
            },
            {
                path: '/flow/workbentch/mySign',
                component: () => import('../views/flow/workbentch/mywork/personSet/mySign.vue'),
                meta: { requireAuth: false, title: '个人设置-我的签名',type:'FLOW' },
            },
            {
                path: '/flow/workbentch/initiateFlow',
                component: () => import('../views/flow/workbentch/mywork/personSet/initiateFlow.vue'),
                meta: { requireAuth: false, title: '个人设置-发起流程',type:'FLOW' },
            },
            {
                path: '/flow/workbentch/allFlows',
                component: () => import('../views/flow/workbentch/flowMgt/allflow/allFlowDef.vue'),
                meta: { requireAuth: false, title: '流程监控 - 所有流程',type:'FLOW' },
            },
            {
                path: '/flow/workbentch/flowMonitor',
                component: () => import('../views/flow/workbentch/flowMgt/flowMonitor/flowMonitorFw.vue'),
                meta: { requireAuth: false, title: '流程监控 - 所有流程',type:'FLOW' },
            },
            {
                path: '/flow/workbentch/flowRanking',
                component: () => import('../views/flow/workbentch/flowMgt/flowMonitor/flowRanking.vue'),
                meta: { requireAuth: false, title: '流程监控 - 流程排行',type:'FLOW' },
            },
        ]
    },
    {
        path: '/orgmgt/flowMgt/flowlnsHistory',
        component: () => import('../views/flow/workbentch/flowMgt/allflow/flowlnsHistory.vue'),
        meta: { requireAuth: false, title: '流程管理-流程历史' },
    },
    {
        path: '/orgmgt/flowMgt/flowAnalyse',
        component: () => import('../views/flow/workbentch/flowMgt/allflow/flowAnalyse.vue'),
        meta: { requireAuth: false, title: '流程管理-流程分析' },
    },
    {
        path: '/upgrade/upgradeFw',
        component: () => import('../views/upgrade/upgradeFw.vue'),
        meta: { requireAuth: false, title: '升级' },
        children: [
            {
                path: '/upgrade/selectVersion',
                component: () => import('../views/upgrade/selectVersion.vue'),
                meta: { requireAuth: false, title: '选择版本' },
            },
            {
                path: '/upgrade/pay',
                component: () => import('../views/upgrade/pay.vue'),
                meta: { requireAuth: false, title: '支付' },
            },
            {
                path: '/upgrade/payResult',
                component: () => import('../views/upgrade/payResult.vue'),
                meta: { requireAuth: false, title: '支付结果' },
            },
        ]
    },
    {
        path: '/sysmgt/sysMgtFw',
        component: () => import('../views/sysmgt/sysMgtFw.vue'),
        meta: { requireAuth: false, title: '系统管理框架页',type:'smsMgt' },
        children: [
            {
                path: '/sysmgt/smsMgt',
                component: () => import('../views/sysmgt/sms/smsMgt.vue'),
                meta: { requireAuth: false, title: '短信服务配置',type:'smsMgt' },
            },
            {
                path: '/sysmgt/qywx',
                component: () => import('../views/sysmgt/qywx/qywx.vue'),
                meta: { requireAuth: false, title: '短信服务配置',type:'smsMgt' },
            },
            {
                path: '/sysmgt/smsTplList',
                component: () => import('../views/sysmgt/sms/smsTplList.vue'),
                meta: { requireAuth: false, title: '短信模板列表',type:'smsMgt' },
            },
            {
                path: '/sysmgt/orgMailMgt',
                component: () => import('../views/sysmgt/mail/mailMgt.vue'),
                meta: { requireAuth: false, title: '邮件配置',type:'smsMgt' },
            },
            {
                path: '/sysmgt/mailMgt',
                component: () => import('../views/sysmgt/mail/mailMgtSet.vue'),
                meta: { requireAuth: false, title: '邮件配置',type:'smsMgt' },
            },
            {
                path: '/sysmgt/ossMgt',
                component: () => import('../views/sysmgt/oss/ossMgt.vue'),
                meta: { requireAuth: false, title: '对象存储配置',type:'smsMgt' },
            },
            {
                path: '/sysmgt/prdtSecret',
                component: () => import('../views/sysmgt/prdtSecret/prdtSecret.vue'),
                meta: { requireAuth: false, title: '产品密钥',type:'smsMgt' },
            },
            {
                path: '/sysmgt/holidays',
                component: () => import('../views/sysmgt/holidays/holidays.vue'),
                meta: { requireAuth: false, title: '节假日管理' },
            },
        ]
    },
    {
        path: '/orgmgt/orgAdminFw',
        component: () => import('../views/orgmgt/orgAdminFw.vue'),
        meta: { requireAuth: false, title: '组织管理框架页',type:'orgmgt' },
        children: [
            {
                path: '/orgmgt/index',
                component: () => import('../views/orgmgt/index.vue'),
                meta: { requireAuth: false, title: '管理后台首页',type:'orgmgt' },
            },
            {
                path: '/orgmgt/orgStruct/depAndPost',
                component: () => import('../views/orgmgt/orgStruct/depAndPost/depAndPost.vue'),
                meta: { requireAuth: false, title: '组织架构-部门与岗位',type:'orgmgt' },
            },
            {
                path: '/orgmgt/orgStruct/depEmp',
                component: () => import('../views/orgmgt/orgStruct/depEmp/depEmp.vue'),
                meta: { requireAuth: false, title: '组织架构-组织成员',type:'orgmgt' },
            },
            {
                path: '/orgmgt/orgStruct/externalEmp',
                component: () => import('../views/orgmgt/orgStruct/externalEmp/externalEmp.vue'),
                meta: { requireAuth: false, title: '组织架构-外部成员',type:'orgmgt' },
            },
            {
                path: '/orgmgt/orgStruct/upDown',
                component: () => import('../views/orgmgt/orgStruct/upDown/upDown.vue'),
                meta: { requireAuth: false, title: '组织架构-上下级关系',type:'orgmgt' },
            },
            {
                path: '/orgmgt/orgStruct/rank',
                component: () => import('../views/orgmgt/orgStruct/rank.vue'),
                meta: { requireAuth: false, title: '组织架构-职级',type:'orgmgt' },
            },
            {
                path: '/orgmgt/orgStruct/dismiss',
                component: () => import('../views/orgmgt/orgStruct/dismiss.vue'),
                meta: { requireAuth: false, title: '组织架构-离职交接',type:'orgmgt' },
            },
            {
                path: '/orgmgt/orgStruct/outUser',
                component: () => import('../views/orgmgt/orgStruct/outUser.vue'),
                meta: { requireAuth: false, title: '组织架构-外部用户',type:'orgmgt' },
            },
            {
                path: '/orgmgt/coop/relateOrg',
                component: () => import('../views/orgmgt/coop/relateOrg.vue'),
                meta: { requireAuth: false, title: '组织协作-关联组织',type:'orgmgt' },
            },
            {
                path: '/orgmgt/orgAuth/orgRoleList',
                component: () => import('../views/orgmgt/orgAuth/orgRoleList.vue'),
                meta: { requireAuth: false, title: '组织权限-组织角色列表',type:'orgmgt' },
            },
            {
                path: '/orgmgt/orgAuth/contactRule',
                component: () => import('../views/orgmgt/orgAuth/contactRule.vue'),
                meta: { requireAuth: false, title: '组织权限-通讯录权限',type:'orgmgt' },
            },
            {
                path: '/orgmgt/orgSet/info',
                component: () => import('../views/orgmgt/orgSet/info.vue'),
                meta: { requireAuth: false, title: '组织设置-组织信息',type:'orgmgt' },
            },
            {
                path: '/orgmgt/orgSet/cstLogin',
                component: () => import('../views/orgmgt/orgSet/cstLogin.vue'),
                meta: { requireAuth: false, title: '组织设置-企业自定义登录页',type:'orgmgt' },
            },
            {
                path: '/orgmgt/orgSet/cstPortal',
                component: () => import('../views/orgmgt/orgSet/cstPortal.vue'),
                meta: { requireAuth: false, title: '组织设置-个性化门户',type:'orgmgt' },
            },
            {
                path: '/orgmgt/appMgt/allApp',
                component: () => import('../views/orgmgt/appMgt/allApp.vue'),
                meta: { requireAuth: false, title: '应用管理-所有应用',type:'orgmgt' },
            },
            {
                path: '/orgmgt/appMgt/appRecycleBin',
                component: () => import('../views/orgmgt/appMgt/appRecycleBin.vue'),
                meta: { requireAuth: false, title: '应用管理-回收站' ,type:'orgmgt'},
            },
            {
                path: '/orgmgt/orgMeetings',
                component: () => import('../views/orgmgt/orgSet/orgMeetings.vue'),
                meta: { requireAuth: false, title: '会议室管理-会议室管理' ,type:'orgmgt'},
            },
            {
                path: '/orgmgt/orgHolidays',
                component: () => import('../views/orgmgt/orgSet/orgHolidays.vue'),
                meta: { requireAuth: false, title: '节假日管理-节假日管理' },
            },
            {
                path: '/orgmgt/appMgt/orgCommunities',
                component: () => import('../views/orgmgt/appMgt/orgCommunities.vue'),
                meta: { requireAuth: false, title: '社区管理-社区管理' ,type:'orgmgt'},
            },
            {
                path: '/orgmgt/other/order',
                component: () => import('../views/orgmgt/other/order.vue'),
                meta: { requireAuth: false, title: '其他-订单' ,type:'orgmgt'},
            },
            {
                path: '/orgmgt/other/smsTpl',
                component: () => import('../views/orgmgt/other/smsTpl.vue'),
                meta: { requireAuth: false, title: '其他-短信模版' ,type:'orgmgt'},
            },
            {
                path: '/orgmgt/other/log',
                component: () => import('../views/orgmgt/other/log/logFw.vue'),
                meta: { requireAuth: false, title: '其他-平台日志' ,type:'orgmgt'},
            },
            {
                path: '/orgmgt/other/notifySet',
                component: () => import('../views/orgmgt/other/notifySet.vue'),
                meta: { requireAuth: false, title: '其他-通知形式' ,type:'orgmgt'},
            },
        ]
    },
    {
        path: '/openPlatFw',
        component: () => import('../views/openPlat/openPlatFw.vue'),
        meta: { requireAuth: false, title: '开放平台',type:'openPlat' },
        children: [
            {
                path: '/openPlat/cstAppList',
                component: () => import('../views/openPlat/cstApp/cstAppList.vue'),
                meta: { requireAuth: false, title: '开放平台-外部应用列表',type:'openPlat' },
            },
            {
                path: '/openPlat/appKey',
                component: () => import('../views/openPlat/appKey.vue'),
                meta: { requireAuth: false, title: '开放平台-api设置',type:'openPlat' },
            },
            {
                path: '/openPlat/qywx',
                component: () => import('../views/openPlat/platlntegrate/qywx.vue'),
                meta: { requireAuth: false, title: '平台集成-企业微信',type:'openPlat' },
            },
            {
                path: '/openPlat/dingding',
                component: () => import('../views/openPlat/platlntegrate/dingding.vue'),
                meta: { requireAuth: false, title: '平台集成-钉钉',type:'openPlat' },
            },
            {
                path: '/openPlat/wp',
                component: () => import('../views/openPlat/platlntegrate/wp.vue'),
                meta: { requireAuth: false, title: '平台集成-微信公众号',type:'openPlat' },
            },
            {
                path: '/openPlat/connector',
                component: () => import('../views/openPlat/connector/connectorList.vue'),
                meta: { requireAuth: false, title: '平台集成-连接器',type:'openPlat' },
            },
            {
                path: '/openPlat/dsTblList',
                component: () => import('../views/openPlat/dataFactory/ds/dsTblList.vue'),
                meta: { requireAuth: false, title: '数据源列表',type:'openPlat' },
            },
            {
                path: '/openPlat/processFlowList',
                component: () => import('../views/openPlat/dataFactory/processFlow/processFlowList.vue'),
                meta: { requireAuth: false, title: '加工流列表',type:'openPlat' },
            }
        ]
    },
    {
        path: '/dataFactory/processConfig',
        component: () => import('../views/openPlat/dataFactory/processFlow/processConfig/processDesignFw.vue'),
        meta: { requireAuth: false, title: '数据工厂' },
        children: [
            {
                path: '/dataFactory/processConfig/processDesign',
                component: () => import('../views/openPlat/dataFactory/processFlow/processConfig/processFlowDesign/processDesign.vue'),
                meta: { requireAuth: false, title: '数据加工器' },
            }
        ]
    },
    {
        path: '/worktbl/workTblConfig/publicDesignFw/:id/:amId/:wtId',
        component: () => import('../views/worktbl/workTblConfig/publicIssue/publicDesign/publicDesignFw.vue'),
        meta: { requireAuth: false, title: '公开设置' },
        children:[
            {
                path: '/worktbl/workTblConfig/publicDesign/:id/:amId/:wtId',
                component: () => import('../views/worktbl/workTblConfig/publicIssue/publicDesign/design/designFw.vue'),
                meta: { requireAuth: false, title: '表单公开设置框架' },
                children:[
                    {
                        path: '/worktbl/workTblConfig/publicDesign/:id/:amId/:wtId/fldSet',
                        component: () => import('../views/worktbl/workTblConfig/publicIssue/publicDesign/design/fldDesign.vue'),
                        meta: { requireAuth: false, title: '表单字段设置页' },
                    },
                    {
                        path: '/worktbl/workTblConfig/publicDesign/:id/:amId/:wtId/styleSet',
                        component: () => import('../views/worktbl/workTblConfig/publicIssue/publicDesign/design/styleDesign.vue'),
                        meta: { requireAuth: false, title: '表单主题设置页' },
                    },
                ]
            },
            {
                path: '/worktbl/workTblConfig/pubSet/:id/:amId/:wtId',
                component: () => import('../views/worktbl/workTblConfig/publicIssue/publicDesign/pubSet.vue'),
                meta: { requireAuth: false, title: '公开配置页' },
            },
        ]
    },
    {
        path: '/sysPrint',
        component: () => import('../views/worktbl/print/sysPrint/sysPrint.vue'),
        meta: { requireAuth: false, title: '系统打印页' },
    }, 
    {
        path: '/pubForm/pubSubmit/:piId',
        component: () => import(/* webpackChunkName: "pubSubmit" */'../views/worktbl/pubForm/pubSubmit.vue'),
        meta: { requireAuth: false, title: '公开提交页' },
    },
    {
        path: '/pubForm/pubSubmit/success/:piId',
        component: () => import('../views/worktbl/pubForm/pubSubmitResult.vue'),
        meta: { requireAuth: false, title: '提交结果页' },
    },
    {
        path: '/knowBase/personSpaceDtl/psPage/:shareCode?',
        component: () => import('../views/knowBase/know/personSpace/psPage.vue'),
        meta: { requireAuth: false, title: '文档详情',type:'' },
    },
    {
        path: '/knowBase/kbHistory',
        component: () => import('../views/knowBase/history/history.vue'),
        meta: { requireAuth: false, title: '知识页历史',type:'KNOW' },
    },
    {
        path: '/knowBase/fileHistory',
        component: () => import('../views/knowBase/history/fileHistory.vue'),
        meta: { requireAuth: false, title: '文件历史',type:'KNOW' },
    },
    {
        path: '/priDeploy/setUrl',
        component: () => import('../views/priDeploy/priPortal.vue'),
        meta: { requireAuth: false, title: '私有化部署' },
        children: [
            {
                path: '/priDeploy/setUrl',
                component: () => import('../views/priDeploy/setUrl.vue'),
                meta: { requireAuth: false, title: '访问地址设置' },
            },
            {
                path: '/priDeploy/inputKey',
                component: () => import('../views/priDeploy/inputKey.vue'),
                meta: { requireAuth: false, title: '请输入你的密钥' },
            },
            {
                path: '/priDeploy/createAdmin',
                component: () => import('../views/priDeploy/createAdmin.vue'),
                meta: { requireAuth: false, title: '设置管理员账户及企业名称' },
            },
            {
                path: '/priDeploy/init',
                component: () => import('../views/priDeploy/init.vue'),
                meta: { requireAuth: false, title: '系统初始化' },
            },
            {
                path: '/priDeploy/setup',
                component: () => import('../views/priDeploy/setup.vue'),
                meta: { requireAuth: false, title: '安装方式' },
            },
            {
                path: '/priDeploy/priSuccess',
                component: () => import('../views/priDeploy/priSuccess.vue'),
                meta: { requireAuth: false, title: '注册成功' },
            },
        ]
    },
    {
        path: '/taskCenterPortal',
        component: () => import('../views/taskCenterPortal/taskCenterPortalFw.vue'),
        meta: { requireAuth: false, title: '任务中心',type:'TASK' },
        children:[
            {
                path: '/myResponsibility',
                component: () => import('../views/taskCenterPortal/myResponsibility/myResponsibility.vue'),
                meta: { requireAuth: false, title: '我负责的',type:'TASK' },
            },
            {
                path: '/myAssignment',
                component: () => import('../views/taskCenterPortal/myAssignment/myAssignment.vue'),
                meta: { requireAuth: false, title: '我分配的',type:'TASK' },
            },
            {
                path: '/myDown',
                component: () => import('../views/taskCenterPortal/myDown/myDown.vue'),
                meta: { requireAuth: false, title: '我下属的',type:'TASK' },
            },
            {
                path: '/myCreation',
                component: () => import('../views/taskCenterPortal/myCreation/myCreation.vue'),
                meta: { requireAuth: false, title: '我创建的',type:'TASK' },
            },
            {
                path: '/allTasks',
                component: () => import('../views/taskCenterPortal/allTasks/allTasks.vue'),
                meta: { requireAuth: false, title: '全部任务',type:'TASK' },
            },
            {
                path: '/allTasksMgt',
                component: () => import('../views/taskCenterPortal/allTasksMgt/allTasksMgt.vue'),
                meta: { requireAuth: false, title: '全部任务',type:'TASK' },
            },
            {
                path: '/completed',
                component: () => import('../views/taskCenterPortal/completed/completed.vue'),
                meta: { requireAuth: false, title: '已完成',type:'TASK' },
            }
        ]
    },
    {
        path: '/scheduleCenterPortal',
        component: () => import('../views/scheduleCenterPortal/scheduleCenterPortalFw.vue'),
        meta: { requireAuth: false, title: '日程中心',type:'schedule' },
    },
    {
        path: '/examMGT',
        component:()=>import('../views/examMGT/portal/portalFw.vue'),
        meta:{ requireAuth:false,title:'培训管理',type:'examMGT' },
        children:[
            {
                path: '/examMGT/courseList',
                component: () => import('../views/examMGT/courseMGT/courseCenter/courseList.vue'),
                meta: { requireAuth: false, title: '课程中心',type:'examMGT' },
            },
            {
                path: '/examMGT/jobCourseList',
                component: () => import('../views/examMGT/courseMGT/jobCourse/jobCourseList.vue'),
                meta: { requireAuth: false, title: '岗位课程',type:'examMGT' },
            },
            {
                path: '/examMGT/examList',
                component: () => import('../views/examMGT/examMGT/examCenter/examList.vue'),
                meta: { requireAuth: false, title: '考试中心',type:'examMGT' },
            },
            {
                path: '/examMGT/examPageList',
                component: () => import('../views/examMGT/examMGT/examPageCenter/examPageList.vue'),
                meta: { requireAuth: false, title: '试卷中心',type:'examMGT' },
            },
            {
                path: '/examMGT/questionList',
                component: () => import('../views/examMGT/examMGT/questionCenter/questionList.vue'),
                meta: { requireAuth: false, title: '题库中心',type:'examMGT' },
            },
            {
                path: '/examMGT/trainPlanList',
                component: () => import('../views/examMGT/trainMGT/trainPlan/trainPlanList.vue'),
                meta: { requireAuth: false, title: '培训计划',type:'examMGT' },
            },
            {
                path: '/examMGT/trainStatistics',
                component: () => import('../views/examMGT/trainMGT/trainStatistics/trainStatistics.vue'),
                meta: { requireAuth: false, title: '培训统计', type: 'examMGT' },
            },
            {
                path: '/examMGT/certificateCenter',
                component: () => import('../views/examMGT/certificateMGT/certificateCenter/certificateCenter.vue'),
                meta: { requireAuth: false, title: '培训计划',type:'examMGT' },
            },
            {
                path: '/examMGT/certificateModel',
                component: () => import('../views/examMGT/certificateMGT/certificateModel/certificateModel.vue'),
                meta: { requireAuth: false, title: '培训计划',type:'examMGT' },
            },
            {
                path: '/examMGT/leaveFieldMapping',
                component: () => import('../views/examMGT/fieldMapping/leaveFieldMapping.vue'),
                meta: { requireAuth: false, title: '映射设置', type: 'examMGT' },
            }
        ]
    },
    {
        path: '/AIMgtFw',
        component: () => import('../views/AIPartner/AIMgt/AIMgtFw.vue'),
        meta: { requireAuth: false, title: 'AI伙伴管理后台',type:'AI' },
        children:[
            {
                path: '/AIMgt/AIModelMgtIndex',
                component: () => import('../views/AIPartner/AIMgt/AIModelMgt/AIModelMgtIndex.vue'),
                meta: { requireAuth: false, title: '模型管理',type:'AI' },
            },
            {
                path: '/AIMgt/AIAgentMgtIndex',
                component: () => import('../views/AIPartner/AIMgt/AIAgentMgt/AIAgentMgtIndex.vue'),
                meta: { requireAuth: false, title: '智能体',type:'AI' },
            },
        ]
    },
    {
        path: '/AIAgentConfigFw',
        component: () => import('../views/AIPartner/AIMgt/AIAgentMgt/AIAgentConfig/AIAgentConfigFw.vue'),
        meta: { requireAuth: false, title: 'AI智能体配置',type:'AI' },
        children:[
            {
                path: '/AIMgt/AIAgentConfig',
                component: () => import('../views/AIPartner/AIMgt/AIAgentMgt/AIAgentConfig/AIAgentConfig.vue'),
                meta: { requireAuth: false, title: 'AI智能体管理',type:'AI' },
            },
            {
                path: '/AIMgt/AIAgentAnaly',
                component: () => import('../views/AIPartner/AIMgt/AIAgentMgt/AIAgentConfig/AIAgentAnaly.vue'),
                meta: { requireAuth: false, title: 'AI智能体分析',type:'AI' },
            },
            {
                path: '/AIMgt/AIAgentScene',
                component: () => import('../views/AIPartner/AIMgt/AIAgentMgt/AIAgentConfig/AIAgentScene.vue'),
                meta: { requireAuth: false, title: 'AI智能体场景',type:'AI' },
            },
        ]
    },
    {
        path: '/supplier',
        component: () => import('../views/supplier/portal/procurePortal.vue'),
        meta: { requireAuth: false, title: '供应商门户',type:'supplier' },
        children:[
            {
                path: '/supplier/pub/login',
                component: () => import('../views/supplier/pub/procureLogin.vue'),
                meta: { requireAuth: false, title: '供应商门户登录页',type:'supplier' },
            },
            {
                path: '/supplier/homePage',
                component: () => import('../views/supplier/homePage/homePage.vue'),
                meta: { requireAuth: false, title: '供应商门户首页',type:'supplier' },
            },
        ]
    },
]